import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
export const fetchGruserSuccess = createAction(`${reduxKey}.GRUSER.FETCH.SUCCESS`, (payload)=>payload);
